// API Endpoints required to fetch data for the home page
import { rivermeadowApi } from './api';

export const home = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        entitlements: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/entitlements?state=allocated,in_use`,
                method: 'GET',
            }),
        }),
        drBackupEntitlements: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/dr-entitlements?size=100`,
                method: 'GET',
            }),
        }),
        activeMigrations: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/migrations/count?state=running`,
                method: 'GET',
            }),
        }),
        scheduledMigrations: builder.query({
            query: ({ userOrg, fromDate, toDate }) => ({
                url: `organizations/${userOrg}/scheduledmigrations/count?from_date=${fromDate}&to_date=${toDate}`,
                method: 'GET',
            }),
        }),
        successMigrations: builder.query({
            query: ({ userOrg, fromDate, toDate }) => ({
                url: `organizations/${userOrg}/migrations/count?state=success&from_date=${fromDate}&to_date=${toDate}`,
                method: 'GET',
            }),
        }),
        errorMigrations: builder.query({
            query: ({ userOrg, fromDate, toDate }) => ({
                url: `organizations/${userOrg}/migrations/count?state=error&from_date=${fromDate}&to_date=${toDate}`,
                method: 'GET',
            }),
        }),
        discoveryMigrationStatus: builder.query({
            query: ({ userOrg, fromDate, toDate }) => ({
                url: `discovery/${userOrg}/migration-status?from_date=${fromDate}&to_date=${toDate}`,
                method: 'GET',
            }),
        }),
        sources: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/sources/count`,
                method: 'GET',
            }),
        }),
        appliances: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/cloudaccounts?size=1000`,
                method: 'GET',
            }),
        }),
        backupAppliances: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/backup-cloudaccounts/count`,
                method: 'GET',
            }),
        }),
        backupPolicies: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/backup-policies?size=1000`,
                method: 'GET',
            }),
        }),
        protectionStatus: builder.query({
            query: ({ policyId }) => ({
                url: `policies/${policyId}/protection-status`,
                method: 'GET',
            }),
        }),
        drAppliances: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/disaster-recovery-cloudaccounts/count`,
                method: 'GET',
            }),
        }),
        drPolicies: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}/policies?size=1000`,
                method: 'GET',
            }),
        }),
        projectDuration: builder.query({
            query: ({ userOrg }) => ({
                url: `organizations/${userOrg}`,
                method: 'GET',
            }),
        }),
        welcomeModal: builder.mutation({
            query: ({ userId }) => ({
                url: `users/${userId}/details`,
                method: 'PUT',
                body: { show_intro: false },
            }),
        }),
    }),
});

export const {
    useActiveMigrationsQuery,
    useScheduledMigrationsQuery,
    useLazyScheduledMigrationsQuery,
    useSuccessMigrationsQuery,
    useLazySuccessMigrationsQuery,
    useErrorMigrationsQuery,
    useLazyErrorMigrationsQuery,
    useDiscoveryMigrationStatusQuery,
    useLazyDiscoveryMigrationStatusQuery,
    useSourcesQuery,
    useAppliancesQuery,
    useEntitlementsQuery,
    useProjectDurationQuery,
    useDrBackupEntitlementsQuery,
    useBackupAppliancesQuery,
    useBackupPoliciesQuery,
    useLazyProtectionStatusQuery,
    useDrAppliancesQuery,
    useDrPoliciesQuery,
    useWelcomeModalMutation,
} = home;
